import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const slides = [{
  word: 'Communities',
  image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1920&q=80'
}, {
  word: 'Opportunities',
  image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1920&q=80'
}, {
  word: 'Investments',
  image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80'
}, {
  word: 'Southwest Florida',
  image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&q=80'
}];
export function HeroSlideshow() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <section className="relative h-screen w-full overflow-hidden bg-black" data-id="element-94" data-mp="3h4p35xis6kwz">
      {/* Crossfading imagery */}
      <AnimatePresence data-id="element-95" data-mp="pcb4e2q32mnf">
        <motion.div key={current} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 1,
        ease: 'linear'
      }} className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: `url(${slides[current].image})`
      }} aria-hidden="true" data-id="element-96" data-mp="pckl0zp8nhgg" />
      </AnimatePresence>
      <div className="absolute inset-0 bg-black/65" aria-hidden="true" data-id="element-97" data-mp="6mcoj0g1np98" />

      {/* Statement */}
      <div className="relative z-10 h-full flex items-center" data-id="element-98" data-mp="3nuge2t9jb05y">
        <div className="max-w-7xl w-full mx-auto px-6 md:px-10" data-id="element-99" data-mp="3nw17ugo0yf2r">
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-[#C5A55A] text-xs md:text-sm tracking-[0.35em] uppercase mb-8" data-id="element-100" data-mp="3stt23hc56da4">
            Real Estate Development
          </motion.p>

          <h1 className="font-serif text-white leading-[0.95]" data-id="element-101" data-mp="1pi4w66x37n3w">
            <motion.span initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="block text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight" data-id="element-102" data-mp="1kjtkrrr594jk">
              Sinclair Develops
            </motion.span>

            <span className="block mt-3 md:mt-5 h-[1.15em] overflow-hidden" data-id="element-103" data-mp="23dz3wmm4k6ff">
              <AnimatePresence mode="wait" data-id="element-104" data-mp="1yjmkudok8x47">
                <motion.span key={slides[current].word} initial={{
                opacity: 0,
                y: '100%'
              }} animate={{
                opacity: 1,
                y: '0%'
              }} exit={{
                opacity: 0,
                y: '-60%'
              }} transition={{
                duration: 0.3,
                ease: [0.23, 1, 0.32, 1]
              }} className="block text-4xl md:text-6xl lg:text-7xl italic text-[#C5A55A]" data-id="element-105" data-mp="1uju77mkb80rz">
                  {slides[current].word}.
                </motion.span>
              </AnimatePresence>
            </span>
          </h1>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.14,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-10 max-w-xl" data-id="element-106" data-mp="hr900f2x3ee4">
            <div className="w-16 h-[2px] bg-[#C5A55A] mb-6" data-id="element-107" data-mp="woi4mah8eens" />
            <p className="text-xl md:text-2xl text-white font-light mb-2" data-id="element-108" data-mp="11g9ok25vtm4y">
              We see what a property can become.
            </p>
            <p className="text-sm md:text-base text-gray-300" data-id="element-109" data-mp="15hv8u8kqx2p6">
              Commercial · Residential · Land · Redevelopment
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-10 flex flex-wrap items-center gap-4" data-id="element-110" data-mp="1ffrguridzhj2">
            <a href="#developments" className="inline-flex items-center gap-2 bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-8 py-4 font-medium rounded-sm transition-colors duration-200" data-id="element-111" data-mp="1bic02o62uyi7">
              See the developments
              <ArrowRight className="w-5 h-5" data-id="element-112" data-mp="dwelv2yqdfc2" />
            </a>
            <Link to="/contact" className="inline-flex items-center border border-white/40 hover:border-[#C5A55A] hover:text-[#C5A55A] text-white px-8 py-4 font-medium rounded-sm transition-colors duration-200" data-id="element-113" data-mp="dxzicy4lv8ck">
              Bring us an opportunity
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Indicators */}
      <div className="absolute bottom-10 left-6 md:left-10 flex gap-3 z-10" data-id="element-114" data-mp="1z8pqybcxerb7">
        {slides.map((slide, index) => <button key={slide.word} onClick={() => setCurrent(index)} className={`h-[3px] transition-all duration-200 ${index === current ? 'bg-[#C5A55A] w-12' : 'bg-white/40 hover:bg-white w-6'}`} aria-label={`Show ${slide.word}`} data-id="element-115" data-mp="26utjztwmg6sm" data-mpi={index} />)}
      </div>
    </section>;
}